import {DatabaseCode, toDatabaseCode} from "./database-code";

export interface InvoiceStatus extends DatabaseCode {
}

const entered: InvoiceStatus = {
  code: 'Entered',
  displayValue: {
    id: 'ots.ui.entity.invoice.status.entered',
    defaultMessage: 'Entered',
  },
};

const approved: InvoiceStatus = {
  code: 'Approved',
  displayValue: {
    id: 'ots.ui.entity.invoice.status.approved',
    defaultMessage: 'Approved',
  },
};

const submitted: InvoiceStatus = {
  code: 'Submitted',
  displayValue: {
    id: 'ots.ui.entity.invoice.status.submitted',
    defaultMessage: 'Submitted',
  },
};

const disputed: InvoiceStatus = {
  code: 'Disputed',
  displayValue: {
    id: 'ots.ui.entity.invoice.status.disputed',
    defaultMessage: 'Disputed',
  },
};

const voided: InvoiceStatus = {
  code: 'Void',
  displayValue: {
    id: 'ots.ui.entity.invoice.status.voided',
    defaultMessage: 'Voided',
  },
};

const paid: InvoiceStatus = {
  code: 'Paid',
  displayValue: {
    id: 'ots.ui.entity.invoice.status.paid',
    defaultMessage: 'Paid',
  },
};

const overdue: InvoiceStatus = {
  code: 'Overdue',
  displayValue: {
    id: 'ots.ui.entity.invoice.status.overdue',
    defaultMessage: 'Overdue',
  },
};

export const invoiceStatus = {
  entered,
  approved,
  submitted,
  disputed,
  voided,
  paid,
  overdue,
};

export const invoiceStatuses = Object.values(invoiceStatus);

export const toInvoiceStatus = (code: string): InvoiceStatus => toDatabaseCode(code, invoiceStatuses);
